var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrenchFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90323 18C13.8203 18 17.8065 13.9706 17.8065 9C17.8065 4.02944 13.8203 0 8.90323 0C3.98611 0 0 4.02944 0 9C0 13.9706 3.98611 18 8.90323 18Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8064 8.99909C17.8069 7.1612 17.2508 5.36721 16.2127 3.85829C15.1747 2.34937 13.7046 1.19787 12 0.558594V17.4388C13.7045 16.7996 15.1745 15.6482 16.2125 14.1395C17.2505 12.6307 17.8067 10.8369 17.8064 8.99909Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41588e-07 8.99909C-0.000351641 10.8369 0.555857 12.6307 1.59386 14.1395C2.63186 15.6482 4.10191 16.7996 5.80639 17.4388V0.558594C4.10179 1.19787 2.63166 2.34937 1.59365 3.85829C0.555634 5.36721 -0.000503163 7.1612 3.41588e-07 8.99909Z",
    fill: "#0052B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchFlag);
export default __webpack_public_path__ + "static/media/FrenchFlag.8fdb6b15b77bb40eb561059f76365962.svg";
export { ForwardRef as ReactComponent };